import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actionBar", "actionButton", "selectedCount", "selectAllCompanies", "selectAllInput", "form"]

  connect() {
    this.updateSelection()
  }

  toggleAll(event) {
    if (!this.hasSelectAllTarget) return
    
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    // Uncheck "select all companies" when unchecking page selection
    if (!checked && this.hasSelectAllCompaniesTarget) {
      this.selectAllCompaniesTarget.checked = false
      if (this.hasSelectAllInputTarget) {
        this.selectAllInputTarget.value = false
      }
    }
    this.updateSelection()
  }

  toggleSelectAll(event) {
    if (!this.hasSelectAllCompaniesTarget) return
    
    const checked = this.selectAllCompaniesTarget.checked
    
    // Update hidden input
    if (this.hasSelectAllInputTarget) {
      this.selectAllInputTarget.value = checked
    }
    
    // If selecting all companies, uncheck individual checkboxes
    if (checked) {
      this.checkboxTargets.forEach(checkbox => {
        checkbox.checked = false
      })
      if (this.hasSelectAllTarget) {
        this.selectAllTarget.checked = false
      }
    }
    
    this.updateSelection()
  }

  toggle(event) {
    // If individual checkbox is checked, uncheck "select all companies"
    if (event.currentTarget.checked && this.hasSelectAllCompaniesTarget) {
      this.selectAllCompaniesTarget.checked = false
      if (this.hasSelectAllInputTarget) {
        this.selectAllInputTarget.value = false
      }
    }
    this.updateSelection()
    this.updateSelectAll()
  }

  updateSelection() {
    // Check if we have the required targets
    if (!this.hasActionBarTarget) return

    const selectAllCompanies = this.hasSelectAllCompaniesTarget && this.selectAllCompaniesTarget.checked
    const selectedOnPage = this.checkboxTargets.filter(cb => cb.checked).length
    const hasSelection = selectAllCompanies || selectedOnPage > 0

    // Show/hide action bar
    if (hasSelection) {
      this.actionBarTarget.classList.remove("hidden")
      if (this.hasActionButtonTarget) {
        this.actionButtonTargets.forEach(btn => {
          btn.disabled = false
        })
      }
    } else {
      this.actionBarTarget.classList.add("hidden")
      if (this.hasActionButtonTarget) {
        this.actionButtonTargets.forEach(btn => {
          btn.disabled = true
        })
      }
    }

    // Update selected count
    if (this.hasSelectedCountTarget) {
      if (selectAllCompanies) {
        this.selectedCountTarget.textContent = "All companies selected"
      } else {
        this.selectedCountTarget.textContent = `${selectedOnPage} selected`
      }
    }
  }

  updateSelectAll() {
    if (!this.hasSelectAllTarget) return
    
    const allChecked = this.checkboxTargets.length > 0 && 
                       this.checkboxTargets.every(cb => cb.checked)
    this.selectAllTarget.checked = allChecked
    this.selectAllTarget.indeterminate = 
      !allChecked && this.checkboxTargets.some(cb => cb.checked)
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  submitAction(event) {
    const form = this.hasFormTarget ? this.formTarget : document.getElementById("bulk-action-form")
    if (!form) return

    const selectAllCompanies = this.hasSelectAllCompaniesTarget && this.selectAllCompaniesTarget.checked
    const selectedIds = this.getSelectedIds()
    
    if (!selectAllCompanies && selectedIds.length === 0) {
      event.preventDefault()
      alert("Please select at least one company or choose 'Select all companies'.")
      return
    }

    // Clear only the company_ids and bulk_action inputs (preserve CSRF token and filter params)
    form.querySelectorAll('input[name="company_ids[]"], input[name="bulk_action"]').forEach(input => input.remove())

    // If select all is checked, don't add individual IDs
    if (!selectAllCompanies) {
      // Add selected company IDs to the form
      selectedIds.forEach(id => {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "company_ids[]"
        input.value = id
        form.appendChild(input)
      })
    }

    // Add the action
    const actionInput = document.createElement("input")
    actionInput.type = "hidden"
    actionInput.name = "bulk_action"
    actionInput.value = event.currentTarget.dataset.actionType
    form.appendChild(actionInput)

    // Submit the form
    form.submit()
  }
}

